import React from 'react';
import Header from './Header';
import SearchBar from './SearchBar';
import TabContents from './TabContents';
import DefaultTabTile from './DefaultTabTile';
import DefaultTabContent from './DefaultTabContent';
import EmptyTabContent from './EmptyTabContent';
import NoInternetContent from './NoInternetContent';
import NotReachableContent from './NotReachableContent';
import TabProvider from '../providers/TabProvider';
import HistoryProvider from '../providers/HistoryProvider';
import Tunnel from './Tunnel';

import ytImg from '../assets/images/react_logo.png';
import vueLogo from '../assets/images/vue_logo.png';
import reduxLogo from '../assets/images/redux_logo.png';
import imjsLogo from '../assets/images/imjs_logo.png';
import goLogo from '../assets/images/golang_logo.png';
import pyLogo from '../assets/images/python_logo.png';
import nodeLogo from '../assets/images/node_logo.png';
import puppeteerLogo from '../assets/images/puppeteer_logo.png';
import jestLogo from '../assets/images/jest_logo.png';
import cucumberLogo from '../assets/images/cucumberjs_logo.png';
import webpackLogo from '../assets/images/webpack_logo.png';
import parcelLogo from '../assets/images/parcel_logo.png';
import aspnetLogo from '../assets/images/aspnet_logo.png';
import sharepointLogo from '../assets/images/sharepoint_logo.png';
import mssqlsrvLogo from '../assets/images/mssqlsrv_logo.png';
import csharpLogo from '../assets/images/csharp_logo.png';
import jqueryLogo from '../assets/images/jquery_logo.png';
import knockoutLogo from '../assets/images/knockout_logo.png';
import resharperLogo from '../assets/images/resharper_logo.png';
import solidLogo from '../assets/images/solid_logo.png';
import firstLogo from '../assets/images/first_logo.png';
import nsisLogo from '../assets/images/nsis_logo.png';
import dockerLogo from '../assets/images/docker_logo.png';
import vscodeLogo from '../assets/images/vscode_logo.png';
import remoteContainersLogo from '../assets/images/remote_containers_logo.png';
import SearchProvider from '../providers/SearchProvider';

function Window() {
  return (
    <div className="window">
      <TabProvider>
        <HistoryProvider>
          <Header></Header>
          <SearchProvider>
            <SearchBar></SearchBar>
          </SearchProvider>
          <TabContents>
            <EmptyTabContent tabId="first" url="https://xn-----8kcbdbp0ap3bibee5azf6m.xn--p1ai" title="Freedom">
              <Tunnel/>
            </EmptyTabContent>
            <DefaultTabContent tabId="first" url="https://maddevs.io" title="Mad Devs">
              <DefaultTabTile
                title="React.js"
                link="https://github.com/facebook/react/"
                icon={ytImg}
                tabIndex={0}
              />
              <DefaultTabTile
                title="Redux"
                link="https://github.com/reduxjs/redux"
                icon={reduxLogo}
                tabIndex={1}
              />
              <DefaultTabTile
                title="Immutable.js"
                link="https://github.com/immutable-js/immutable-js"
                icon={imjsLogo}
                tabIndex={2}
              />
              <DefaultTabTile
                title="Vue.js"
                link="https://github.com/vuejs/vue"
                icon={vueLogo}
                tabIndex={3}
              />
              <DefaultTabTile
                title="Go"
                link="https://github.com/golang/go"
                icon={goLogo}
                tabIndex={4}
              />
              <DefaultTabTile
                title="Python"
                link="https://github.com/python/cpython"
                icon={pyLogo}
                tabIndex={5}
              />
              <DefaultTabTile
                title="Node.js"
                link="https://github.com/nodejs/node"
                icon={nodeLogo}
                tabIndex={6}
              />
              <DefaultTabTile
                title="Puppeteer"
                link="https://github.com/GoogleChrome/puppeteer"
                icon={puppeteerLogo}
                tabIndex={7}
              />
              <DefaultTabTile
                title="Jest"
                link="https://github.com/facebook/jest"
                icon={jestLogo}
                tabIndex={8}
              />
              <DefaultTabTile
                title="Cucumber.js"
                link="https://github.com/cucumber/cucumber-js"
                icon={cucumberLogo}
                tabIndex={9}
              />
              <DefaultTabTile
                title="Webpack"
                link="https://github.com/webpack/webpack"
                icon={webpackLogo}
                tabIndex={10}
              />
              <DefaultTabTile
                title="Parcel"
                link="https://github.com/parcel-bundler/parcel"
                icon={parcelLogo}
                tabIndex={12}
              />
              <DefaultTabTile
                title="Docker"
                link="https://www.docker.com/"
                icon={dockerLogo}
                tabIndex={13}
              />
              <DefaultTabTile
                title="VSCode"
                link="https://code.visualstudio.com/"
                icon={vscodeLogo}
                tabIndex={14}
              />
              <DefaultTabTile
                title="Remote-Containers"
                link="https://marketplace.visualstudio.com/items?itemName=ms-vscode-remote.remote-containers"
                icon={remoteContainersLogo}
                tabIndex={15}
              />
            </DefaultTabContent>
            <DefaultTabContent tabId="first" url="https://nambataxi.kg" title="Namba Taxi">
              <DefaultTabTile
                title="React.js"
                link="https://github.com/facebook/react/"
                icon={ytImg}
                tabIndex={0}
              />
              <DefaultTabTile
                title="Immutable.js"
                link="https://github.com/immutable-js/immutable-js"
                icon={imjsLogo}
                tabIndex={2}
              />
              <DefaultTabTile
                title="Go"
                link="https://github.com/golang/go"
                icon={goLogo}
                tabIndex={4}
              />
              <DefaultTabTile
                title="Python"
                link="https://github.com/python/cpython"
                icon={pyLogo}
                tabIndex={5}
              />
              <DefaultTabTile
                title="Node.js"
                link="https://github.com/nodejs/node"
                icon={nodeLogo}
                tabIndex={6}
              />
              <DefaultTabTile
                title="Jest"
                link="https://github.com/facebook/jest"
                icon={jestLogo}
                tabIndex={8}
              />
              <DefaultTabTile
                title="Webpack"
                link="https://github.com/webpack/webpack"
                icon={webpackLogo}
                tabIndex={10}
              />
            </DefaultTabContent>
            <DefaultTabContent tabId="first" url="https://counterpart.org" title="Counterpart">
              <DefaultTabTile
                title="ASP.NET"
                link="https://dotnet.microsoft.com/apps/aspnet"
                icon={aspnetLogo}
                tabIndex={0}
              />
              <DefaultTabTile
                title="SharePoint"
                link="https://products.office.com/ru-ru/sharepoint/collaboration"
                icon={sharepointLogo}
                tabIndex={1}
              />
              <DefaultTabTile
                title="MS SQL Server"
                link="https://www.microsoft.com/ru-ru/sql-server/sql-server-2017-editions#CP_StickyNav_1"
                icon={mssqlsrvLogo}
                tabIndex={2}
              />
              <DefaultTabTile
                title="C#"
                link="https://github.com/dotnet/csharplang"
                icon={csharpLogo}
                tabIndex={3}
              />
              <DefaultTabTile
                title="JQuery"
                link="https://jquery.com/"
                icon={jqueryLogo}
                tabIndex={4}
              />
              <DefaultTabTile
                title="Knockout.js"
                link="https://knockoutjs.com/"
                icon={knockoutLogo}
                tabIndex={5}
              />
            </DefaultTabContent>
            <DefaultTabContent tabId="first" url="http://ikeen.com" title="Via Systems">
              <DefaultTabTile
                title="ASP.NET"
                link="https://dotnet.microsoft.com/apps/aspnet"
                icon={aspnetLogo}
                tabIndex={0}
              />
              <DefaultTabTile
                title="MS SQL Server"
                link="https://www.microsoft.com/ru-ru/sql-server/sql-server-2017-editions#CP_StickyNav_1"
                icon={mssqlsrvLogo}
                tabIndex={2}
              />
              <DefaultTabTile
                title="C#"
                link="https://github.com/dotnet/csharplang"
                icon={csharpLogo}
                tabIndex={3}
              />
              <DefaultTabTile
                title="Resharper"
                link="https://www.jetbrains.com/resharper/"
                icon={resharperLogo}
                tabIndex={5}
              />
              <DefaultTabTile
                title="NSIS"
                link="https://nsis.sourceforge.io/Download"
                icon={nsisLogo}
                tabIndex={5}
              />
              <DefaultTabTile
                title="S.O.L.I.D"
                link="https://itnext.io/solid-principles-explanation-and-examples-715b975dcad4"
                icon={solidLogo}
                tabIndex={5}
              />
              <DefaultTabTile
                title="F.I.R.S.T"
                link="https://hackernoon.com/test-f-i-r-s-t-65e42f3adc17"
                icon={firstLogo}
                tabIndex={5}
              />
            </DefaultTabContent>
            <NoInternetContent tabId="second" url=""/>
            <NotReachableContent></NotReachableContent>
          </TabContents>
        </HistoryProvider>
      </TabProvider>
    </div>
  );
}

export default Window;
